const Utils = require('./utils.js');
const Constants = require('./constants.js');

const DEFAULTS = {
  color: "#fff",
  width: 1200,
  height: 800
};

class InfoScreen {
  constructor (options = {}) {
    let settings = Object.assign(DEFAULTS,options);
    this.width = settings.width;
    this.height = settings.height;
    this.color = settings.color;
    this.kingColor = "red";
    this.game = settings.game;
    this.revealed = true; //for testing
    this.xPos = this.width * 0.7 + 2;
    this.kingPos = {
      action: "",
      leftArm: [0,0],
      rightArm: [0,0],
      leftLeg: [0,0],
      rightLeg: [0,0],
      pole: [0,0],
      body: [0,0]
    };
    this.agePos = {
      10: [0,0],
      20: [0,0],
      30: [0,0],
      50: [0,0]
    };
    this.text = {
      header: "Age 1",
      beginning: true,
      startGame: false,
      instructions: false,
      betweenAges: false,
      inGame: false,
      council: false,
      colors: true,
      showAges: false,
      endGame: false,
      loseGame: false,
      ageMove: false,
      ageSelect: "20",
      ageSelected: false,
      begin: false,
      decision: false,
      kingReveal: true,
      showAge: false,
      betweenAgeMessage: ["Before you begin, you must pick a specialty for"+
      " your kingdom:", this.currentBetweenAgeMessage],
      firstContent: "Thank you for playing Shapes of War. You will play as "+
      "the ruler of the Circle Kingdom. Please pick a color...",
      colorChoices: ["blue", "green", "yellow", "red"],
      currentBetweenAgeMessage: [
        "Strength will mostly affect your subjects' ability to harvest food "+
        "and engage in warfare. Strength is best utilized with large populations.",
        "Intelligence addresses future needs over more pressing issues. Disease "+
        "control, technology advancement, and efficient management of food are "+
        "all affected by intelligence.", "The deceitful leader doesn't worry "+
        "about internal prosperity. Winning is measured against others, and through "+
        "devious schemes, deceitful leaders excel in comparison by bringing "+
        "down those around them.", "A jack of all trades, but master of none. "+
        "Mediocrity is to some what general excellence is to others. Have no "+
        "weaknesses and only you can hold yourself back."
      ],
      instructionsText: ["There are three stages of decision making that take "+
      "place before playing out the turn: (1) Population management, (2) " +
      "Setting your goal, and (3) Picking a target (pick yourself to defend). ",
      "When managing your population, you should set your workers to a number "+
      "that produces enough food to feed your population. 40% is generally a "+
      "safe number. The rest should be divided between military and educators.",
      "Once you allocate your population, you will pick a goal for that age. "+
      "Goals will include bonuses to various stats or actions you wish to "+
      "take.", "Finally, you will select a target to attack. Each player "+
      "will select a target and attack simulataneously. The turn will "+
      "resolve once all attacks have concluded."],
      currentBetweenAgeMessageSelected: 0,
      positiveChoice: "",
      negativeChoice: "",
      population: "10",
      perkExplanationText: "",
      size: "big",
      climate: "hot",
      diseaseRate: "minimal",
      foodStorage: "plenty",
      powerLevel: "strong",
      events: {
        culled: "a few",
        born: "a lot",
        disease: "a few",
        oldAge: "a few",
        starved: "a bit"
      },
      avgInt: 100,
      avgStr: 100,
      avgHealth: 100
    };

    this.currentIntelChoice = "";
  }

  show (options) {
    this.revealed = true;
  }

  resetScreens (exceptFor) {
    this.text.beginning = exceptFor === "beginning" ? true : false;
    this.text.council = exceptFor === "council" ? true : false;
    this.text.instructions = exceptFor === "instructions" ? true : false;
    this.text.betweenAges = exceptFor === "betweenAges" ? true : false;
    this.text.managingPop = exceptFor === "managePop" ? true : false;
    this.text.decision = exceptFor === "decision" ? true : false;
    this.text.startGame = exceptFor === "startGame" ? true : false;
    this.text.endGame = exceptFor === "endGame" ? true : false;
    this.text.loseGame = exceptFor === "loseGame" ? true : false;
  }

  bringUpCouncil () {
    this.resetScreens("council");
    this.text.kingReveal = true;
  }

  goBetweenAges () {
    this.text.perkExplanationText = "";
    this.resetScreens("betweenAges");
    this.text.kingReveal = true;
  }

  endGame () {
    this.resetScreens("betweenAges");
    this.text.kingReveal = true;
    this.kingPos.action = "jumpDown";
    this.text.endGame = true;
  }

  loseGame () {
    this.resetScreens("betweenAges");
    this.text.endGame = true;
    this.text.loseGame = true;
  }

  hide () {
    this.text.showAge = false;
    this.revealed = false;
    this.text.kingReveal = false;
    this.xPos = this.width * 0.7 + 2;
  }

  selectKingColor (color) {
    this.game.gameAudio.click.get();
    this.kingColor = color;
  }

  selectAge (age) {
    this.game.gameAudio.click.get();
    this.text.ageSelect = age;
  }

  setBetweenAgeMessage () {
    this.results = this.game.humanPlayer.latestResults;
    this.events = this.game.humanPlayer.events;
  }

  resumeGame () {
    this.hide();
    this.resetScreens();
  }

  hideIfAllowed () {
    if (this.council) {
      this.hide();
    }
  }

  setPerkExplanation (command) {
    this.game.gameAudio.click.get();
    this.text.perkExplanationText = Constants[command];
  }

  setAge () {
    this.text.ageSelected = true;
    this.text.showAges = false;
    this.text.showAge = true;
    this.text.ageMove = true;

    this.token = window.setTimeout(()=> {
      this.offerDecision();
      this.text.firstContent = "Ahh, brave. Brave, indeed. Quite brave. Are you " +
      "ready to begin your journey, or would you like me to remind you how " +
      "to lead a kingdom?";
      this.text.positiveChoice = "'Yes, I am ready to conquer the Polygons. "+
      "They will be nothing but lines and points after I'm finished "+
      "with them!'";
      this.text.negativeChoice = "'Of course I bloody know how to run a "+
      "kingdom!.. but... I want you to prove to me that you do, as well.'";
    },1250);

    this.ageXDis = this.width * (0.22 + ((parseInt(this.text.ageSelect ===
      "50" ? "40" : this.text.ageSelect) / 10) * 0.08)) - 135;
    this.ageYDis = this.height / 3 - this.height * 0.1 - 90;

    if (this.text.ageSelect === "10" && Math.abs(this.agePos[10][0]) <
      this.ageXDis) {
      this.agePos[10][0] -= 4;
      if (Math.abs(Math.abs(this.agePos[10][1])) < this.ageYDis) {
        this.agePos[10][1] -= 1;
      }
    } else if (this.text.ageSelect === "20" && Math.abs(this.agePos[20][0]) <
      this.ageXDis) {
        this.agePos[20][0] -= 5;
        if (Math.abs(Math.abs(this.agePos[20][1])) < this.ageYDis) {
          this.agePos[20][1] -= 1;
        }
    } else if (this.text.ageSelect === "30" && Math.abs(this.agePos[30][0]) <
      this.ageXDis) {
        this.agePos[30][0] -= 6;
        if (Math.abs(Math.abs(this.agePos[30][1])) < this.ageYDis) {
          this.agePos[30][1] -= 1;
        }
    } else if (this.text.ageSelect === "50" && Math.abs(this.agePos[50][0]) <
      this.ageXDis) {
        this.agePos[50][0] -= 7;
        if (Math.abs(Math.abs(this.agePos[50][1])) < this.ageYDis) {
          this.agePos[50][1] -= 1;
        }
    } else {
      this.text.ageMove = false;
    }
  }

  setColor () {
    window.setTimeout(()=>{
      this.text.colors = false;
      this.text.firstContent = "Thank you, my liege. I have a good feeling "+
      "about you. Now, how many ages would you like to play?";
      this.showAges();
    },1500);
    this.kingPos.action = "jumpDown";
  }

  showAges () {
    this.text.showAge = true;
    this.text.showAges = true;
  }

  selectChoice(choice) {
    if (choice === "positive-beginning") {
      this.game.setStage("betweenAges");
    } else if (choice === "negative-beginning") {
      this.game.setStage("instructions");
      this.giveInstructions();
    }
  }

  giveInstructions () {
    this.resetScreens('instructions');
  }

  offerDecision () {
    this.resetScreens("decision");
  }

  managePop () {
    this.resetScreens("managePop");
  }

  startGame () {
    this.hide();
    this.resetScreens();
  }

  kingSitDown () {
    this.kingPos = {
      action: "",
      leftArm: [0,0],
      rightArm: [0,0],
      leftLeg: [0,0],
      rightLeg: [0,0],
      pole: [0,0],
      body: [0,0]
    };
  }

  kingJumpDown () {
    //pushing up
    if (this.kingPos.body[0] >= -8 && this.kingPos.body[1] <= 0) {
      this.kingPos.body[0] -= 1;
      this.kingPos.body[1] -= 1;
      this.kingPos.rightArm[0] -= 1;
      this.kingPos.rightArm[1] -= 1;
      this.kingPos.pole[0] -= 1;
      this.kingPos.pole[1] -= 1;
      //falling down
    } else if (this.kingPos.body[0] > -15 && this.kingPos.body[1] <= 0) {
        this.kingPos.body[0] -= 1;
        this.kingPos.body[1] += 1;
        this.kingPos.leftArm[0] -= 3;
        this.kingPos.pole[0] -= 1;
        this.kingPos.rightArm[0] -= 1;
        this.kingPos.rightArm[1] += 1;
        this.kingPos.pole[1] += 1;
        this.kingPos.leftLeg[0] -= 1;
        this.kingPos.leftLeg[1] += 1;
        this.kingPos.rightLeg[0] -= 1;
        this.kingPos.rightLeg[1] += 1;
        //falling down straight

    } else if (this.kingPos.body[0] === -15 && this.kingPos.body[1] < 170) {
        this.kingPos.body[1] += 3;
        if (this.kingPos.body[1] > 40) {
          this.kingPos.leftArm[1] += 3;
        }
        this.kingPos.rightArm[1] += 3;
        this.kingPos.pole[1] += 3;
        this.kingPos.leftLeg[1] += 3;
        this.kingPos.rightLeg[1] += 3;
        //pumping arm

    } else if (this.kingPos.body[1] > 167 &&
      this.kingPos.rightArm[0] > -25 &&
      this.kingPos.rightArm[1] < 185 &&
      (!this.text.endGame || this.game.victory)) {
        this.kingPos.rightArm[0] -= 1;
        this.kingPos.rightArm[1] += 2;
        if (this.kingPos.leftArm[1] < 170) {
          this.kingPos.leftArm[1] += 3;
        }
        this.kingPos.pole[0] -= 1;
        this.kingPos.pole[1] += 2;
        if (this.kingPos.rightLeg[1] < 210) {
          this.kingPos.rightLeg[1] += 1;
        }
        //raising arm

      } else if (this.kingPos.leftArm[1] < 170) {
        this.kingPos.leftArm[1] += 3;
        if (this.kingPos.rightLeg[1] < 210) {
          this.kingPos.rightLeg[1] += 1;
        }
      } else if (this.kingPos.rightArm[0] < -14 &&
        this.kingPos.rightArm[1] > 120 &&
         (!this.text.endGame || this.game.victory)) {
        this.kingPos.rightArm[0] -= 1;
        this.kingPos.rightArm[1] -= 5;
        this.kingPos.pole[0] -= 1;
        this.kingPos.pole[1] -= 5;
      }

  }

  setSelectedTextDescription (type,selected) {
    if (type === "selectPerk"){
      this.text.currentBetweenAgeMessageSelected = selected;
    }
  }

  draw (ctx) {
    let yPos = this.height * 0.10 + 2;
    if (this.revealed && this.xPos > 0) {
      this.xPos -= 10;
    }
    if (this.text.beginning) {
      this.xPos = 0;
    }

    if (this.kingPos.action === "jumpDown") {
      this.kingJumpDown();
    }

    if (this.text.ageMove) {
      this.setAge();
    }

    ctx.beginPath();
    ctx.rect(this.xPos, yPos, this.width, this.height * 0.9 - 2);
    ctx.fillStyle = "lightgrey";
    ctx.lineWidth = 5;
    ctx.strokeStyle = 'black';
    ctx.stroke();
    ctx.fill();

    if (this.text.kingReveal) {
      //throne back
      ctx.beginPath();
      ctx.moveTo(this.xPos + 50,yPos + 18);
      ctx.lineTo(this.xPos + 55,yPos + 248);
      ctx.lineTo(this.xPos + 215,yPos + 248);
      ctx.lineTo(this.xPos + 220,yPos + 18);
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "#672c00";
      ctx.fill();
      ctx.stroke();

      //throne seat
      ctx.beginPath();
      ctx.moveTo(this.xPos + 55,yPos + 248);
      ctx.lineTo(this.xPos + 45,yPos + 268);
      ctx.lineTo(this.xPos + 225,yPos + 268);
      ctx.lineTo(this.xPos + 215,yPos + 248);
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "#290d0d";
      ctx.fill();
      ctx.stroke();

      //throne base
      ctx.beginPath();
      ctx.moveTo(this.xPos + 44,yPos + 270);
      ctx.lineTo(this.xPos + 44,yPos + 470);
      ctx.lineTo(this.xPos + 226,yPos + 470);
      ctx.lineTo(this.xPos + 226,yPos + 270);
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "#672c00";
      ctx.fill();
      ctx.stroke();

      //throne arm rests
      ctx.beginPath();
      ctx.moveTo(this.xPos + 44,yPos + 268);
      ctx.lineTo(this.xPos + 44,yPos + 208);
      ctx.lineTo(this.xPos + 64,yPos + 208);
      ctx.lineTo(this.xPos + 64,yPos+268);
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "brown";
      ctx.fill();
      ctx.stroke();

      //king
      ctx.beginPath();
      ctx.arc(
        this.xPos + 135 + this.kingPos.body[0],
        yPos + 190 + this.kingPos.body[1], 75,0,2*Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();

      //eyes
      ctx.beginPath();
      ctx.ellipse(
        this.xPos + 105 + this.kingPos.body[0],
        yPos + 160 + this.kingPos.body[1],
        15, 20, -20 * Math.PI/180, 0, 2 * Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(
        this.xPos + 107 + this.kingPos.body[0],
        yPos + 165 + this.kingPos.body[1], 5,0,2*Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "black";
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.ellipse(
        this.xPos + 165 + this.kingPos.body[0],
        yPos + 160 + this.kingPos.body[1],
        15, 20, 20 * Math.PI/180, 0, 2 * Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(
        this.xPos + 163 + this.kingPos.body[0],
        yPos + 165 + this.kingPos.body[1], 5,0,2*Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "black";
      ctx.fill();
      ctx.stroke();

      //king arms
      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 68 + this.kingPos.body[0],
        yPos + 205 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 50 + this.kingPos.leftArm[0],
        yPos + 205 + this.kingPos.leftArm[1]
      );
      ctx.lineTo(
        this.xPos + 50 + this.kingPos.leftArm[0],
        yPos + 197 + this.kingPos.leftArm[1]
      );
      ctx.lineTo(
        this.xPos + 68 + this.kingPos.body[0],
        yPos + 197 + this.kingPos.body[1]
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();

      //king hands
      ctx.beginPath();
      ctx.ellipse(
        this.xPos + 50 + this.kingPos.leftArm[0],
        yPos + 200 + this.kingPos.leftArm[1],
        10, 15, Math.PI/180, 0, 2 * Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      //king armrest
      ctx.beginPath();
      ctx.moveTo(this.xPos + 206,yPos + 268);
      ctx.lineTo(this.xPos + 206,yPos + 208);
      ctx.lineTo(this.xPos + 226,yPos + 208);
      ctx.lineTo(this.xPos + 226,yPos+268);
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "brown";
      ctx.fill();
      ctx.stroke();

      //king arms
      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 206 + this.kingPos.body[0],
        yPos + 205 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 236 + this.kingPos.rightArm[0],
        yPos + 205 + this.kingPos.rightArm[1]
      );
      ctx.lineTo(
        this.xPos + 236 + this.kingPos.rightArm[0],
        yPos + 197 + this.kingPos.rightArm[1]
      );
      ctx.lineTo(
        this.xPos + 206 + this.kingPos.body[0],
        yPos + 197 + this.kingPos.body[1]
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();

      //king staff
      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 232 + this.kingPos.pole[0],
        yPos + 280 + this.kingPos.pole[1]
      );
      ctx.lineTo(
        this.xPos + 232 + this.kingPos.pole[0],
        yPos + 150 + this.kingPos.pole[1]
      );
      ctx.lineTo(
        this.xPos + 240 + this.kingPos.pole[0],
        yPos + 150 + this.kingPos.pole[1]
      );
      ctx.lineTo(
        this.xPos + 240 + this.kingPos.pole[0],
        yPos + 280 + this.kingPos.pole[1]
      );
      ctx.closePath();
      ctx.lineWidth = 3;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "gold";
      ctx.fill();
      ctx.stroke();

      //staff gem
      ctx.beginPath();
      ctx.arc(
        this.xPos + 236 + this.kingPos.pole[0],
        yPos + 145 + this.kingPos.pole[1],10,0,2*Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();

      //king hand right
      ctx.beginPath();
      ctx.ellipse(
        this.xPos + 236 + this.kingPos.rightArm[0],
        yPos + 200 + this.kingPos.rightArm[1],
        10, 15, Math.PI/180, 0, 2 * Math.PI
      );
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      //king crown
      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 95 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 100 + this.kingPos.body[0],yPos + 70 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 120 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 150 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 170 + this.kingPos.body[0],yPos + 70 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 175 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.lineJoin = "miter";
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "#b76b04";
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 100 + this.kingPos.body[0],yPos + 120 + this.kingPos.body[1]
      );
      ctx.bezierCurveTo(
        this.xPos + 123 + this.kingPos.body[0],
        yPos + 125 + this.kingPos.body[1],
        this.xPos + 146 + this.kingPos.body[0],
        yPos + 125 + this.kingPos.body[1],
        this.xPos + 170 + this.kingPos.body[0],
        yPos + 120 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 190 + this.kingPos.body[0],yPos + 70 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 165 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 135 + this.kingPos.body[0],yPos + 70 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 105 + this.kingPos.body[0],yPos + 95 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 80 + this.kingPos.body[0],yPos + 70 + this.kingPos.body[1]
      );
      ctx.closePath();
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "gold";
      ctx.fill();
      ctx.stroke();

      //Ruby on crown
      ctx.beginPath();
      ctx.arc(this.xPos + 135 + this.kingPos.body[0],yPos + 100 +
        this.kingPos.body[1],10,0,2*Math.PI);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "red";
      ctx.fill();
      ctx.stroke();

      //king shoes
      ctx.beginPath();
      ctx.ellipse(this.xPos + 150 + this.kingPos.rightLeg[0], yPos + 300 +
        this.kingPos.rightLeg[1], 15, 20, 90 * Math.PI/180, 0, 2 * Math.PI);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.ellipse(this.xPos + 85 + this.kingPos.leftLeg[0], yPos + 300 +
        this.kingPos.leftLeg[1], 15, 20, 90 * Math.PI/180, 0, 2 * Math.PI);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "white";
      ctx.fill();
      ctx.stroke();

      //king legs
      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 95 + this.kingPos.body[0],
        yPos + 240 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 85 + this.kingPos.leftLeg[0],
        yPos + 270 + this.kingPos.leftLeg[1]
      );
      ctx.lineTo(
        this.xPos + 85 + this.kingPos.leftLeg[0],
        yPos + 290 + this.kingPos.leftLeg[1]
      );
      ctx.bezierCurveTo(
        this.xPos + 88 + this.kingPos.leftLeg[0],
        yPos + 292 + this.kingPos.leftLeg[1],
        this.xPos + 92 + this.kingPos.leftLeg[0],
        yPos + 292 + this.kingPos.leftLeg[1],
        this.xPos + 95 + this.kingPos.leftLeg[0],
        yPos + 290 + this.kingPos.leftLeg[1]
      );
      ctx.lineTo(
        this.xPos + 95 + this.kingPos.leftLeg[0],
        yPos + 270 + this.kingPos.leftLeg[1]
      );
      ctx.lineTo(
        this.xPos + 105 + this.kingPos.body[0],
        yPos + 250 + this.kingPos.body[1]
      );
      ctx.lineWidth = 5;
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(
        this.xPos + 155 + this.kingPos.body[0],
        yPos + 240 + this.kingPos.body[1]
      );
      ctx.lineTo(
        this.xPos + 145 + this.kingPos.rightLeg[0],
        yPos + 270 + this.kingPos.rightLeg[1]
      );
      ctx.lineTo(
        this.xPos + 145 + this.kingPos.rightLeg[0],
        yPos + 290 + this.kingPos.rightLeg[1]
      );
      ctx.bezierCurveTo(
        this.xPos + 148 + this.kingPos.rightLeg[0],
        yPos + 292 + this.kingPos.rightLeg[1],
        this.xPos + 152 + this.kingPos.rightLeg[0],
        yPos + 292 + this.kingPos.rightLeg[1],
        this.xPos + 155 + this.kingPos.rightLeg[0],
        yPos + 290 + this.kingPos.rightLeg[1]
      );
      ctx.lineTo(
        this.xPos + 155 + this.kingPos.rightLeg[0],
        yPos + 270 + this.kingPos.rightLeg[1]
      );
      ctx.lineTo(
        this.xPos + 165 + this.kingPos.body[0],
        yPos + 250 + this.kingPos.body[1]
      );
      ctx.lineWidth = 5;
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.kingColor;
      ctx.fill();
      ctx.stroke();
    }

    if (this.text.beginning) {
      //Intro text - pick a color
      let linesFirst = Utils.fragmentText(this.text.firstContent,this.width *
        0.8 - 275 - parseInt(this.height * 0.018,0), ctx);
      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      linesFirst.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.26 + 250, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.12);
      });

      //colors
      if (this.text.colors) {
        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.3,this.height / 3,this.height *
          0.05 + 10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "red";
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.38,this.height / 3,this.height *
          0.05 + 10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "lightblue";
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.46,this.height / 3,this.height *
          0.05 + 10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "green";
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.54,this.height / 3,this.height *
          0.05 + 10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "purple";
        ctx.fill();
        ctx.stroke();
      }

      //submit button
      if (!this.text.decision) {
        ctx.beginPath();
        ctx.rect(this.xPos + this.width * 0.371,this.height * 0.455,this.width *
          0.1,this.height * 0.05 + 10);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "limegreen";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = 'black';
        ctx.fillText(
          "Decide", this.xPos + this.width * 0.425,this.height * 0.493
        );
      }

    } else if (this.text.instructions) {
      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'left';
      ctx.fillStyle = 'black';
      let instructionsFirst = Utils.fragmentText(
        this.text.instructionsText[0],
        this.width * 0.45 - parseInt(this.height * 0.018,0), ctx
      );

      let instructionsSecond = Utils.fragmentText(
        this.text.instructionsText[1],
        this.width * 0.45 - parseInt(this.height * 0.018,0), ctx
      );

      let instructionsThird = Utils.fragmentText(
        this.text.instructionsText[2],
        this.width * 0.45 - parseInt(this.height * 0.018,0), ctx
      );

      let instructionsFourth = Utils.fragmentText(
        this.text.instructionsText[3],
        this.width * 0.45 - parseInt(this.height * 0.018,0), ctx
      );

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      instructionsFirst.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.41, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.15);
      });

      instructionsSecond.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.41, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.3);
      });

      instructionsThird.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.41, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.48);
      });

      instructionsFourth.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.41, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.6);
      });

    } else if (this.text.betweenAges || this.text.managingPop) {
      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(
        `Age ${this.game.currentAge}`, this.xPos +
        this.width * 0.42,this.height * 0.15
      );
      if (this.game.currentAge === 0) {
        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = 'black';
        ctx.fillText(
          this.text.betweenAgeMessage[0], this.xPos +
          this.width * 0.40,this.height * 0.20
        );

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.text.currentBetweenAgeMessageSelected === 0 ?
          'limegreen' : 'black';
        ctx.fillText(
          "Strength", this.xPos +
          this.width * 0.3,this.height * 0.35
        );

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.text.currentBetweenAgeMessageSelected === 1 ?
        'limegreen' : 'black';
        ctx.fillText(
          "Intelligence", this.xPos +
          this.width * 0.5,this.height * 0.35
        );

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.text.currentBetweenAgeMessageSelected === 2 ?
          'limegreen' : 'black';
        ctx.fillText(
          "Devious", this.xPos +
          this.width * 0.3,this.height * 0.5
        );

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = this.text.currentBetweenAgeMessageSelected === 3 ?
          'limegreen' : 'black';
        ctx.fillText(
          "A little bit of everything", this.xPos +
          this.width * 0.5,this.height * 0.5
        );

        let selectedPerkDescription = Utils.fragmentText(
          this.text.currentBetweenAgeMessage[this.text.currentBetweenAgeMessageSelected],
          this.width * 0.45 - parseInt(this.height * 0.018,0), ctx
        );

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = 'black';
        selectedPerkDescription.forEach((line, i) => {
          ctx.fillText(line, this.xPos + this.width * 0.41, (i + 1) *
          parseInt(this.height * 0.025 + 5,0) + this.height * 0.65);
        });

        ctx.beginPath();
        ctx.rect(this.xPos + this.width * 0.315,this.height * 0.79,this.width *
          0.2,this.height * 0.05 + 10);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = "limegreen";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = 'black';
        ctx.fillText(
          "Ok, let's play already!", this.xPos + this.width * 0.42,this.height * 0.83
        );
      } else {
        if (!this.text.managingPop) {
          if (!this.game.unlockPerks) {
            if (this.game.currentAge === 1) {
              ctx.fillStyle = "black";
              ctx.fillText(
                "Land, ho!", this.xPos + this.width * 0.42,this.height * 0.2
              );

              let explanationTextBot = Utils.fragmentText(
                "We have had some time to survey the land, and take a census of our "+
                "circlezens, and this is how we stand:",
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'left';

              explanationTextBot.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
              });
            }
          } else if (this.game.unlockPerks) {

            if (this.game.currentAge > 1) {
              ctx.beginPath();
              ctx.rect(
                this.xPos + this.width * 0.47, this.height * 0.49,
                this.width * 0.24,this.height * 0.51 + 3);
              ctx.lineWidth = 3;
              ctx.strokeStyle = 'black';
              ctx.fillStyle = "lightblue";
              ctx.fill();
              ctx.stroke();

              ctx.textAlign = 'left';
              ctx.fillStyle = 'black';

              ctx.fillText(
                "Results from last age:", this.xPos + this.width * 0.48,this.height * 0.53
              );

              ctx.fillText(
                "Captured Land (+/-):", this.xPos + this.width * 0.48,this.height * 0.58
              );

              ctx.fillText(
                "Captured Food (+/-):", this.xPos + this.width * 0.48,this.height * 0.63
              );

              ctx.fillText(
                "Casualties:", this.xPos + this.width * 0.48,this.height * 0.68
              );

              ctx.fillText(
                "Relative Strength:", this.xPos + this.width * 0.48,this.height * 0.73
              );

              ctx.fillText(
                "Born this age:", this.xPos + this.width * 0.48,this.height * 0.78
              );

              ctx.fillText(
                "Number starved:", this.xPos + this.width * 0.48,this.height * 0.83
              );

              ctx.fillText(
                "Succumbed to old age:", this.xPos + this.width * 0.48,this.height * 0.88
              );

              ctx.fillText(
                "Succumbed to disease:", this.xPos + this.width * 0.48,this.height * 0.93
              );

              ctx.fillText(
                "Succumbed to elements:", this.xPos + this.width * 0.48,this.height * 0.98
              );

              ctx.fillText(
                `${Math.floor(this.results.capturedLand * 100)}%`, this.xPos + this.width * 0.63,this.height * 0.58
              );

              ctx.fillText(
                `${Math.floor(this.results.capturedFood)} bushels`, this.xPos + this.width * 0.63,this.height * 0.63
              );

              ctx.fillText(
                this.results.casualties || 0, this.xPos + this.width * 0.63,this.height * 0.68
              );

              ctx.fillText(
                `${Math.floor(this.results.relativeStrength.toFixed(2) * 100)}%`, this.xPos + this.width * 0.63,this.height * 0.73
              );

              ctx.fillText(
                this.events.numBorn, this.xPos + this.width * 0.63,this.height * 0.78
              );

              ctx.fillText(
                this.events.starving, this.xPos + this.width * 0.63,this.height * 0.83
              );

              ctx.fillText(
                this.events.oldAge, this.xPos + this.width * 0.63,this.height * 0.88
              );

              ctx.fillText(
                this.events.health, this.xPos + this.width * 0.63,this.height * 0.93
              );

              ctx.fillText(
                this.events.numCulled, this.xPos + this.width * 0.63,this.height * 0.98
              );



            }

            ctx.fillStyle = "black";

            if (!this.text.endGame) {
              let explanationText = Utils.fragmentText(
                this.text.perkExplanationText === "" ? "Pick a goal" :
                (this.text.perkExplanationText ? this.text.perkExplanationText : ""),
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'center';

              explanationText.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.42, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
              });
            }
          }

          ctx.beginPath();
          ctx.rect(
            this.xPos + this.width * 0.35, this.height * 0.345,
            this.width * 0.1,this.height * 0.04 + 3);
          ctx.lineWidth = 3;
          ctx.strokeStyle = 'black';
          ctx.fillStyle = "lightblue";
          ctx.fill();
          ctx.stroke();
          ctx.textAlign = 'center';


          ctx.fillStyle = "black";

          if (this.text.endGame) {
            ctx.fillText(
              "Replay", this.xPos + this.width * 0.4,this.height * 0.375
            );
          } else {
            ctx.fillText(
              "Manage", this.xPos + this.width * 0.4,this.height * 0.375
            );
          }


          ctx.textAlign = 'right';

          ctx.fillText(
            "Population:", this.xPos + this.width *
              0.17 + 215,this.height * 0.43
          );

          ctx.fillText(
            "Average Strength:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.5
          );

          ctx.fillText(
            "Average Intelligence:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.57
          );

          ctx.fillText(
            "Average Health:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.64
          );

          ctx.fillText(
            "Land size:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.71
          );

          ctx.fillText(
            "Useable Land:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.78
          );

          ctx.fillText(
            "Food storage:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.85
          );

          ctx.fillText(
            "Climate:", this.xPos + this.width * 0.17 + 215,
              this.height * 0.92
          );

          ctx.textAlign = 'left';

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.population),
              this.xPos + this.width * 0.17 + 250,this.height * 0.43
          );

          ctx.fillText(
            `(${this.game.humanPlayer.country.object.males.length} males and ${this.game.humanPlayer.country.object.females.length} females)`,
              this.xPos + this.width * 0.17 + 315,this.height * 0.43
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.avgStr), this.xPos +
              this.width * 0.17 + 250,this.height * 0.5
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.avgInt), this.xPos +
              this.width * 0.17 + 250,this.height * 0.57
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.avgHealth), this.xPos +
              this.width * 0.17 + 250,this.height * 0.64
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.size), this.xPos +
              this.width * 0.17 + 250,this.height * 0.71
          );

          ctx.fillText(
            "acres", this.xPos +
              this.width * 0.17 + 325,this.height * 0.71
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.farmableLand), this.xPos +
              this.width * 0.17 + 250,this.height * 0.78
          );

          ctx.fillText(
            "acres", this.xPos +
              this.width * 0.17 + 325,this.height * 0.78
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.foodStorage), this.xPos +
              this.width * 0.17 + 250,this.height * 0.85
          );

          ctx.fillText(
            "pounds", this.xPos +
              this.width * 0.17 + 325,this.height * 0.85
          );

          ctx.fillText(
            Math.floor(this.game.humanPlayer.country.object.climate), this.xPos +
              this.width * 0.17 + 250,this.height * 0.92
          );

          ctx.fillText(
            "degrees", this.xPos +
              this.width * 0.17 + 325,this.height * 0.92
          );
        }
        if (this.text.endGame) {
          if (this.text.loseGame) {
            let explanationText = Utils.fragmentText(
              "Oh no! You lost! Below are the last records we have of the " +
              "circle kingdom.",
              this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
            );

            ctx.textAlign = 'left';

            explanationText.forEach((line, i) => {
              ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
              parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
            });
          } else {
            if (this.game.victory) {
              let explanationText = Utils.fragmentText(
                "Congrats! You prevailed victorious, my liege!",
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'left';

              explanationText.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
              });
            } else {
              let explanationText = Utils.fragmentText(
                "The game is over! Unfortunately, you finished " +
                `${this.game.place} `+ "among the surviving kingdoms",
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'left';

              explanationText.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
              });
            }
          }
        } else if (this.text.managingPop) {
          if (this.game.currentAge === 1) {
            if (this.game.unlockPerks) {
              let explanationText = Utils.fragmentText(
                "That was close! Now, the last thing we need to do is decide"+
                " on the goal for the next age. Generally, you want to pick"+
                " something that addresses immediate issues, but if you think"+
                " we can get away with it, the earlier we focus on "+
                "technology, the sooner we will begin to reap its benefits.",
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'left';

              explanationText.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.2);
              });

              ctx.beginPath();
              ctx.rect(
                this.xPos + this.width * 0.35, this.height * 0.345,
                this.width * 0.1,this.height * 0.04 + 3);
              ctx.lineWidth = 3;
              ctx.strokeStyle = 'black';
              ctx.fillStyle = "lightblue";
              ctx.fill();
              ctx.stroke();

              ctx.textAlign = "center";
              ctx.fillStyle = "black";
              ctx.fillText(
                "Got it", this.xPos + this.width * 0.4,this.height * 0.375
              );
            } else {
              let explanationText = Utils.fragmentText(
                "Oh no! There are some lazy *#?! dots amongst our citizenry "+
                "not doing anything productive. Let's fix that.",
                this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
              );

              ctx.textAlign = 'left';

              explanationText.forEach((line, i) => {
                ctx.fillText(line, this.xPos + this.width * 0.1 + 125, (i + 1) *
                parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
              });

              ctx.beginPath();
              ctx.rect(
                this.xPos + this.width * 0.35, this.height * 0.345,
                this.width * 0.1,this.height * 0.04 + 3);
              ctx.lineWidth = 3;
              ctx.strokeStyle = 'black';
              ctx.fillStyle = "lightblue";
              ctx.fill();
              ctx.stroke();

              ctx.textAlign = "center";
              ctx.fillStyle = "black";
              ctx.fillText(
                "Back", this.xPos + this.width * 0.4,this.height * 0.375
              );
            }
          } else {
            let explanationText = Utils.fragmentText(
              "Allocate your population as you desire",
              this.width * 0.5 - parseInt(this.height * 0.018,0), ctx
            );

            ctx.textAlign = 'center';

            explanationText.forEach((line, i) => {
              ctx.fillText(line, this.xPos + this.width * 0.4, (i + 1) *
              parseInt(this.height * 0.025 + 5,0) + this.height * 0.23);
            });

            ctx.beginPath();
            ctx.rect(
              this.xPos + this.width * 0.35, this.height * 0.345,
              this.width * 0.1,this.height * 0.04 + 3);
            ctx.lineWidth = 3;
            ctx.strokeStyle = 'black';
            ctx.fillStyle = "lightblue";
            ctx.fill();
            ctx.stroke();

            ctx.textAlign = "center";
            ctx.fillStyle = "black";
            ctx.fillText(
              "Back", this.xPos + this.width * 0.4,this.height * 0.375
            );
          }
          ctx.fillStyle = 'red';
          ctx.fillText(
            `Percentage of unallocated population:
              ${100 - (this.game.humanPlayer.country.options.workerPercentage +
              this.game.humanPlayer.country.options.militaryPercentage +
              this.game.humanPlayer.country.options.educatorPercentage)}`,
              this.xPos + this.width * 0.4,this.height * 0.7
          );

          ctx.fillStyle = "black";

          ctx.fillText(
            "-               +",
            this.xPos + this.width * 0.4,this.height * 0.43
          );

          ctx.fillText(
            this.game.humanPlayer.country.options.workerPercentage,
            this.xPos + this.width * 0.4,this.height * 0.43
          );

          ctx.fillText(
            "Percentage as workers (100% farming / 50% defense)", this.xPos +
              this.width * 0.4,this.height * 0.47
          );

          ctx.fillText(
            "-               +",
            this.xPos + this.width * 0.4,this.height * 0.51
          );

          ctx.fillText(
            this.game.humanPlayer.country.options.militaryPercentage,
              this.xPos + this.width * 0.4,this.height * 0.51
          );

          ctx.fillText(
            "Percentage to military (100% attack and defend / 50% farm)", this.xPos +
              this.width * 0.4,this.height * 0.55
          );

          ctx.fillText(
            "-               +",
            this.xPos + this.width * 0.4,this.height * 0.59
          );

          ctx.fillText(
            this.game.humanPlayer.country.options.educatorPercentage,
              this.xPos + this.width * 0.4,this.height * 0.59
          );

          ctx.fillText(
            "Percentage to education (100% technology gains)",
              this.xPos + this.width * 0.4,this.height * 0.63
          );
        }
      }
    }

    if (this.text.council) {
      let soldiers = Math.floor(
        (this.game.humanPlayer.country.options.militaryPercentage / 100) *
        this.game.humanPlayer.country.object.population
      );
      let councilMsg;
      if (this.game.currentAge === 1) {
        councilMsg = `You have ${soldiers} soldiers available to deploy. You can `+
        "either keep them home for defense, where they will also join the work "+
        "force at half productivity, or you can deploy them to attack another "+
        "country. Depending on the military differential at the time of "+
        "attack, you will gain territory and food, at the expense of "+
        "suffering casualties. Alternatively, if you have chosen an espionage "+
        "move for this age, your warships will be used in furtherance of that.";
      } else {
        //post age 1 message
        councilMsg = `You have ${soldiers} soldiers at your disposal. Select how you will use them.`;
      }

      let lines = Utils.fragmentText(councilMsg, this.width *
        0.6 - parseInt(this.height * 0.018,0), ctx);
      ctx.font = `${this.height * 0.012 + 3}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      lines.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.45, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.12);
      });

      this.text.playerCountry = this.game.humanPlayer.countryNo;

      ctx.beginPath();
      ctx.arc(this.xPos + this.width * 0.35,
        this.height * 0.5,this.height * 0.1,0,2*Math.PI);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = this.text.playerCountry === 0 ? "green" : "red";
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.fillText(
        this.text.playerCountry === 0 ? "stay home" : "attack", this.xPos +
          this.width * 0.35,this.height * 0.5 + this.height * 0.006 + 2
      );

      ctx.beginPath();
      ctx.arc(this.xPos + this.width * 0.35,
        this.height * 0.8,this.height * 0.1,0,2*Math.PI);
      ctx.fillStyle = this.text.playerCountry === 1 ? "green" : "red";
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.fillText(
        this.text.playerCountry === 1 ? "stay home" : "attack", this.xPos +
          this.width * 0.35,this.height * 0.8 + this.height * 0.006 + 2
      );

      ctx.beginPath();
      ctx.arc(this.xPos + this.width * 0.55,
        this.height * 0.5,this.height * 0.1,0,2*Math.PI);
      ctx.fillStyle = this.text.playerCountry === 2 ? "green" : "red";
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.fillText(
        this.text.playerCountry === 2 ? "stay home" : "attack", this.xPos +
          this.width * 0.55,this.height * 0.5 + this.height * 0.006 + 2
      );

      ctx.beginPath();
      ctx.arc(this.xPos + this.width * 0.55,
        this.height * 0.8,this.height * 0.1,0,2*Math.PI);
      ctx.fillStyle = this.text.playerCountry === 3 ? "green" : "red";
      ctx.fill();
      ctx.stroke();

      ctx.fillStyle = 'black';

      ctx.fillText(
        this.text.playerCountry === 3 ? "stay home" : "attack", this.xPos +
          this.width * 0.55,this.height * 0.8 + this.height * 0.006 + 2
      );

    }

    //ages select
    if (this.text.showAge) {
      //10
      if (this.text.showAges || this.text.ageSelect === "10") {
        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.3 + this.agePos[10][0],
          this.height / 3 + this.agePos[10][1],this.height * 0.05 +
          10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = this.text.ageSelect === "10" ? "turquoise" : "grey";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.025}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = "black";
        ctx.fillText("10", this.width * 0.30 + this.agePos[10][0],
        this.height / 3 + this.agePos[10][1] + this.height * 0.0125);
      }

      //20
      if (this.text.showAges || this.text.ageSelect === "20") {
        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.38 + this.agePos[20][0],
          this.height / 3 + this.agePos[20][1],this.height * 0.05 +
          10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = this.text.ageSelect === "20" ? "turquoise" :  "grey";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.02 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = "black";
        ctx.fillText("20", this.width * 0.38 + this.agePos[20][0],
        this.height / 3 + this.agePos[20][1] + this.height * 0.0125);
      }

      //30
      if (this.text.showAges || this.text.ageSelect === "30") {
        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.46 + this.agePos[30][0],
          this.height / 3 + this.agePos[30][1],this.height * 0.05 +
          10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = this.text.ageSelect === "30" ? "turquoise" :  "grey";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.02 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = "black";
        ctx.fillText("30", this.width * 0.46 + this.agePos[30][0],
        this.height / 3 + this.agePos[30][1] + this.height * 0.0125);
      }

      //50
      if (this.text.showAges || this.text.ageSelect === "50") {
        ctx.beginPath();
        ctx.arc(this.xPos + this.width * 0.54 + this.agePos[50][0],
          this.height / 3 + this.agePos[50][1],this.height * 0.05 +
          10,0,2*Math.PI);
        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = this.text.ageSelect === "50" ? "turquoise" :  "grey";
        ctx.fill();
        ctx.stroke();

        ctx.font = `${this.height * 0.02 + 5}pt helvetica`;
        ctx.textAlign = 'center';
        ctx.fillStyle = "black";
        ctx.fillText("50", this.width * 0.54 + this.agePos[50][0],
        this.height / 3 + this.agePos[50][1] + this.height * 0.0125);
      }
    }

    if (this.text.decision) {
      //decision
      //affirmative button
      ctx.beginPath();
      ctx.rect(this.xPos + this.width * 0.58,this.height * 0.3,this.width *
        0.1,this.height * 0.05 + 10);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "limegreen";
      ctx.fill();
      ctx.stroke();

      //negative button
      ctx.beginPath();
      ctx.rect(this.xPos + this.width * 0.58,this.height * 0.455,this.width *
        0.1,this.height * 0.05 + 10);
      ctx.lineWidth = 5;
      ctx.strokeStyle = 'black';
      ctx.fillStyle = "#900606";
      ctx.fill();
      ctx.stroke();

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(
        "Select", this.xPos + this.width * 0.63,this.height * 0.34
      );

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      ctx.fillText(
        "Select", this.xPos + this.width * 0.63,this.height * 0.493
      );

      let linesFirst = Utils.fragmentText(this.text.firstContent,this.width *
        0.6 - 275 - parseInt(this.height * 0.018,0), ctx);
      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'center';
      ctx.fillStyle = 'black';
      linesFirst.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.26 + 250, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.12);
      });

      // affirmative response
      let positiveLines = Utils.fragmentText(this.text.positiveChoice,
        this.width * 0.4 - parseInt(this.height * 0.018,0), ctx);

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'left';
      ctx.fillStyle = '#3e3838';
      positiveLines.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.185, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.30);
      });

      //negative response
      let negativeLines = Utils.fragmentText(this.text.negativeChoice,
        this.width * 0.4 - parseInt(this.height * 0.018,0), ctx);

      ctx.font = `${this.height * 0.012 + 5}pt helvetica`;
      ctx.textAlign = 'left';
      ctx.fillStyle = '#3e3838';
      negativeLines.forEach((line, i) => {
        ctx.fillText(line, this.xPos + this.width * 0.185, (i + 1) *
        parseInt(this.height * 0.025 + 5,0) + this.height * 0.455);
      });
    }
  }
}

module.exports = InfoScreen;



/*****************
 ** WEBPACK FOOTER
 ** ./game/views/information_screen.js
 ** module id = 9
 ** module chunks = 0
 **/